import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=08e42c4c&"
import script from "./ContactDialog.vue?vue&type=script&lang=ts&"
export * from "./ContactDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports